module.exports = __webpack_public_path__ + "img/mission-item-bg3.c99153fc.png";